import { ModernLoggedOut } from '@fiverr-private/header';

export default ModernLoggedOut;
